import React from 'react';

import NotFound from '@components/NotFound';

export default function Page404() {
  return <NotFound />;
}
